import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { computed, reactive, onActivated, ref } from 'vue';
export const useQueryProxy = (props, {
  onAfterLoadData = undefined,
  sortFormater = undefined
}) => {
  const {
    enablePager: enablePagerProp = true,
    currentPage: currentPageProp = 1,
    pageSize: pageSizeProp = 1,
    total: totalProp = 0,
    rows: rowProps = [],
    queryConfig: queryConfigProp = {}
  } = props || {};
  const enablePager = ref(enablePagerProp);
  const currentPage = ref(currentPageProp || 1);
  const pageSize = ref(pageSizeProp || 50);

  // 列表数据参数
  const rows = ref([...rowProps]);
  const total = ref(totalProp || 0);
  const queryParams = ref({});
  const sortFields = ref([]);
  const queryConfig = reactive({
    api: '',
    params: undefined,
    // ({ currentPage, pageSize, params }) => ({ currentPage, pageSize, params }), // 查询附带的参数，可为object或返回参数的function
    beforeQuery: params => true,
    // 返回false取消查询
    after: undefined,
    // ({ rows, total, currentPage, pageSize }) => ({ rows, total, currentPage, pageSize }) // 查询后的数据处理
    sortParam: 'sort',
    // 排序参数字段名称
    sortFormater: fields => fields.map(item => `${item.field} ${item.order}`).join(','),
    pagerFields: {
      currentPage: 'pi',
      pageSize: 'ps'
    },
    respFields: {
      rows: 'rows',
      total: 'total',
      currentPage: 'pi',
      pageSize: 'ps'
    },
    ...queryConfigProp
  });
  const updatePagerConfig = ({
    currentPage: pi,
    pageSize: ps,
    enablePager: b
  }) => {
    currentPage.value = pi;
    pageSize.value = ps;
    enablePager.value = b;
  };
  const updateQueryParams = (params = {}) => {
    queryParams.value = {
      ...params
    };
  };
  const updateSortFields = (fields = []) => {
    sortFields.value = [...fields];
  };
  const updateQueryConfig = (config = {}) => {
    Object.assign(queryConfig, config);
  };
  const {
    runAsync: loadDataFn,
    loading,
    error
  } = fetchApi({
    'getName'() {
      return queryConfig.api;
    }
  });
  const enableQuery = computed(() => {
    return !!queryConfig.api;
  });
  const getResponseData = data => {
    const {
      respFields
    } = queryConfig;
    const {
      [`${respFields.rows}` || 'rows']: rows = [],
      [`${respFields.total}` || 'total']: total = 0,
      [`${respFields.currentPage}` || 'currentPage']: currentPage = 1,
      [`${respFields.pageSize}` || 'pageSize']: pageSize = 50
    } = data || {};
    return {
      rows: rows || [],
      total: total || 0,
      currentPage: currentPage || 1,
      pageSize: pageSize || 50
    };
  };
  const doBeforeQuery = async (currentPage, pageSize, params, sort) => {
    const result = {
      currentPage,
      pageSize,
      params,
      sort
    };
    const {
      params: extraQueryParams
    } = queryConfig;
    if (typeof extraQueryParams === 'function') {
      const {
        currentPage: resPi,
        pageSize: resPs,
        params: resParams,
        sort: resSort
      } = await extraQueryParams({
        currentPage,
        pageSize,
        params: {
          ...params
        },
        sort
      });
      Object.assign(result, {
        currentPage: resPi,
        pageSize: resPs,
        params: resParams,
        sort: resSort
      });
    } else if (typeof extraQueryParams === 'object') {
      result.params = {
        ...params,
        ...extraQueryParams
      };
    }
    return result;
  };
  const doAfterQuery = async (params, data) => {
    let {
      rows,
      total,
      currentPage,
      pageSize
    } = data;
    const {
      after: queryAfter
    } = queryConfig;
    if (typeof queryAfter === 'function') {
      const {
        rows: tmpRows,
        total: tmpTotal,
        currentPage: tmpCurrentPage,
        pageSize: tmpPageSize
      } = await queryAfter({
        params,
        currentPage,
        pageSize,
        total,
        rows
      });
      rows = tmpRows || [];
      total = tmpTotal || 0;
      currentPage = tmpCurrentPage || 1;
      pageSize = tmpPageSize || 50;
    }
    if (onAfterLoadData && typeof onAfterLoadData === 'function') {
      onAfterLoadData({
        params,
        rows,
        total,
        currentPage,
        pageSize
      });
    }
    return {
      rows,
      total,
      currentPage,
      pageSize
    };
  };

  // 构造查询参数
  const createQueryParams = async (useOld, callParams) => {
    const tmpParams = {};
    if (useOld) {
      Object.assign(tmpParams, queryParams.value);
    }
    Object.assign(tmpParams, callParams || {});
    return {
      currentPage: currentPage.value,
      pageSize: pageSize.value,
      params: tmpParams,
      sort: sortFields.value || []
    };
  };
  const formatPostParams = prepareParams => {
    const {
      currentPage,
      pageSize,
      params,
      sort
    } = prepareParams;
    const {
      pagerFields
    } = queryConfig;
    let sortVal = sort || [];
    if (!!sortFormater && typeof sortFormater === 'function') {
      sortVal = sortFormater(sortVal);
    } else if (!!queryConfig.sortFormater && typeof queryConfig.sortFormater === 'function') {
      sortVal = queryConfig.sortFormater(sortVal);
    }
    return {
      pager: {
        [`${pagerFields.currentPage}` || 'pi']: currentPage,
        [`${pagerFields.pageSize}` || 'ps']: pageSize
      },
      params: {
        ...params,
        [queryConfig.sortParam]: sortVal
      }
    };
  };
  const fetchData = async fetchParams => {
    if (!!queryConfig.beforeQuery && typeof queryConfig.beforeQuery === 'function') {
      const continueQuery = queryConfig.beforeQuery(fetchParams);
      if (!continueQuery) return Promise.resolve({
        rows: [],
        total: 0
      });
    }
    const {
      error: resError,
      ...res
    } = await loadDataFn(fetchParams || {});
    if (resError) {
      error.value = resError;
    }
    const {
      rows: resRow,
      total: resTotal,
      currentPage: pi,
      pageSize: ps
    } = getResponseData(res);
    const {
      rows: afterRows,
      total: afterTotal,
      currentPage: afterCurrentPage,
      pageSize: afterPageSize
    } = await doAfterQuery(queryParams.value, {
      rows: resRow,
      total: resTotal,
      currentPage: pi,
      pageSize: ps
    });
    rows.value = afterRows;
    total.value = afterTotal;
    currentPage.value = afterCurrentPage;
    pageSize.value = afterPageSize;
  };
  const margeFetchParams = ({
    pager: prePager,
    params
  }) => {
    const result = {
      ...params
    };
    if (enablePager.value) {
      Object.assign(result, prePager);
    }
    return result;
  };

  // 加载数据，不保留之前查询参数
  const loadData = async callParams => {
    if (!enableQuery.value || loading.value) return;
    const {
      currentPage,
      pageSize,
      params,
      sort
    } = await createQueryParams(false, callParams);
    const postParams = await doBeforeQuery(currentPage, pageSize, params, sort);
    const {
      pager,
      params: prepareParams
    } = formatPostParams(postParams);
    queryParams.value = prepareParams;
    const fetchParams = margeFetchParams({
      pager,
      params: prepareParams
    });
    await fetchData(fetchParams);
  };
  const refresh = async callParams => {
    if (!enableQuery.value || loading.value) return;
    const {
      currentPage,
      pageSize,
      params,
      sort
    } = await createQueryParams(true, callParams);
    const postParams = await doBeforeQuery(currentPage, pageSize, params, sort);
    const {
      pager,
      params: prepareParams
    } = formatPostParams(postParams);
    queryParams.value = prepareParams;
    const fetchParams = margeFetchParams({
      pager,
      params: prepareParams
    });
    await fetchData(fetchParams);
  };

  // 重新加载数据，页面会重置为1
  const reloadData = async callParams => {
    currentPage.value = 1;
    return loadData(callParams);
  };
  const loadPage = async (pi, ps) => {
    currentPage.value = pi;
    pageSize.value = ps;
    return refresh();
  };
  const remoteSortData = async (fields = []) => {
    sortFields.value = [...fields];
    currentPage.value = 1;
    return refresh();
  };
  onActivated(() => {
    return loadData();
  });
  return {
    enableQueryProxy: enableQuery,
    sortFields,
    error,
    loading,
    queryParams,
    enablePager,
    currentPage,
    pageSize,
    rows,
    total,
    loadData,
    reloadData,
    refresh,
    loadPage,
    updatePagerConfig,
    updateQueryParams,
    updateQueryConfig,
    remoteSortData,
    updateSortFields
  };
};